import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { asArray } from '@nu-art/ts-common';
import { Component_TagGroups } from '@app/hcs-frontend/tag';
export class Section_PathwayTags extends ComponentSync {
    __onPathwayUpdated(...params) {
        if (asArray(params[1]).every(pathway => pathway._id !== this.state.pathway._id))
            return;
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.pathway = nextProps.pathway;
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'pathways-tags', children: [_jsx("div", { className: 'pathways-tags__title', children: "Tags" }), _jsx(LL_V_L, { className: 'pathways-tags__container', children: _jsx(Component_TagGroups, { tagGroups: this.state.pathway.tagGroups }) })] });
    }
}
//# sourceMappingURL=Section_PathwayTags.js.map